import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import AdminPage from "@/components/AdminPage";
import VoiceOrb from "@/components/VoiceOrb";
import GuideBot from "@/components/GuideBot";
import { getSessionId } from "@/utils/session";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Workforce from "@/components/Workforce";
import Capabilities from "@/components/Capabilities";
import CommandCenter from "@/components/CommandCenter";
import Comparison from "@/components/Comparison";
import Pricing from "@/components/Pricing";
import FinalCTA from "@/components/FinalCTA";
import ChatWidget from "@/components/ChatWidget";
import DemoModal from "@/components/DemoModal";

function Landing() {
  const [orbOpen, setOrbOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOrbOpen(true);
    window.addEventListener("open-voice-orb", handler);
    return () => window.removeEventListener("open-voice-orb", handler);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({
      autoRaf: true,
      lerp: 0.09,
      anchors: { offset: -72 },
    });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] font-body text-[#F5F5F5] antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Workforce />
        <Capabilities />
        <CommandCenter />
        <Comparison />
        <Pricing />
        <FinalCTA />
      </main>
      <ChatWidget />
      <DemoModal />
      <GuideBot />
      <AnimatePresence>
        {orbOpen && (
          <VoiceOrb sessionId={getSessionId()} onClose={() => setOrbOpen(false)} />
        )}
      </AnimatePresence>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
